import React, { useState } from "react";
import logo from "./logo-grups.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
      </header>
    </div>
  );
}

export default App;